export default __webpack_public_path__ + "static/media/hhn3.30b1f2eb.png";